import { Injectable } from '@angular/core';
import {
  AppConfigService,
  CookieStorageService,
  LocalStorageService,
} from '@core/index';
import { prop } from 'ramda';

@Injectable({ providedIn: 'root' })
export class RWBABTestingService {
  constructor(
    public cookieStorageService: CookieStorageService,
    public appConfigService: AppConfigService,
    public localStorageService: LocalStorageService,
  ) {}

  getRwbBookerUrl(): string | undefined {
    return (
      this.getRWBBookerUrlFromLocalStorage() ||
      this.appConfigService.rwbBookerUrl
    );
  }

  getRWBBookerUrlFromLocalStorage(): string | undefined {
    return (
      (this.isNonProdEnvironment() &&
        prop(
          'url',
          this.localStorageService.getItem<{ url?: string }>('rwbBookerURL'),
        )) ||
      undefined
    );
  }

  isNonProdEnvironment(): boolean {
    return !this.appConfigService.isProdEnv;
  }
}
